import { ReactNode } from 'react';

import PrevNextButton from '../PrevNextButton/PrevNextButton';

import styles from './CalendarHeader.module.css';

type CalendarHeaderProps = {
    children: ReactNode;
};

const CalendarHeader = ({ children }: CalendarHeaderProps) => {
    return (
        <header className={styles.Root}>
            <PrevNextButton direction="previous" slot="previous" />

            <div className={styles.Heading}>{children}</div>

            <PrevNextButton direction="next" slot="next" />
        </header>
    );
};

export default CalendarHeader;
